module.exports = __webpack_public_path__ + "img/s_whitepurpleD-logo.bcaba66.png";